module.exports = __webpack_public_path__ + "img/gym.a0f84b0c.jpg";